import React from 'react';

const NotificationCount = ({ count }) => {
  if (count <= 0) return null;
  if (count > 99) return <span className="notificationCount hundredNotificationCount">99+</span>;
  return <span className="notificationCount">{count}</span>;
};

export default NotificationCount;
